import { useEffect } from 'react';
import { Button, Typography } from 'mobily-ui-library/lib';

import './ErrorModal.scss';

interface Props {
    id: string;
    rtl: boolean;
    title: string;
    description: string;
    firstButtonText: string;
    secButtonText?: string;
    modalFirstButtonClick: () => void;
    modalSecondButtonClick?: () => void;
    className?: string;
}

function ErrorModal({ id, rtl, title, description, firstButtonText, secButtonText, modalFirstButtonClick, modalSecondButtonClick,className }: Props) {

    useEffect(() => {
        document.body.style.overflow = 'hidden';
    }, []);

    return (
        <div className={rtl ? 'Error__ModalContainer Error__ModalRight' : 'Error__ModalContainer'}>
            <div className='Error__Fallback'></div>
             <div className={`Error__Modal ${className || ""}`} id={id}>
                <Typography rtl={rtl} className='Error__MT'>{title}</Typography>
                <Typography rtl={rtl} className='Error__MST'>{description}</Typography>

                <Button rtl={rtl} className='Error__MButton' onClick={modalFirstButtonClick}>{firstButtonText}</Button>
                {secButtonText && <Button rtl={rtl} className='Error__MButton Error__SecButton' onClick={modalSecondButtonClick}>{secButtonText}</Button>}
            </div>
        </div>
    )
}

export default ErrorModal;